module.exports = __webpack_public_path__ + "img/main-image.318b34ea.jpeg";